import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit, signal } from '@angular/core';
import { FaqService } from '../../services/faq.service';
import { takeUntil } from 'rxjs';
import { FaqItemComponent } from '../../components/faq-item/faq-item.component';
import { BaseComponent } from '../../../../components/core/components/base/base.component';
import { Faq } from '../../../../data-access/models/faq.model';
import { HOME_ROUTE } from '../../../../data-access/constants/app-routes';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { NgxAppBarComponent } from '@digipay/ngx-app-bar';
import { TabComponent } from '../../../../shared/components/tab/tab.component';
import { TabsComponent } from '../../../../shared/components/tabs/tabs.component';
import { SpinnerComponent } from '../../../../shared/components/spinner/spinner.component';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  imports: [FaqItemComponent, NgxAppBarComponent, TabComponent, TabsComponent, SpinnerComponent],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqComponent extends BaseComponent implements OnInit {
  isLoading = signal<boolean>(false);
  faqs = signal<{ fixedIncome: Faq[]; stock: Faq[] } | undefined>(undefined);

  private cdr = inject(ChangeDetectorRef);
  private navigationService = inject(WealthNavigationService);
  private faqService = inject(FaqService);

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.faqService
      .getFaq()
      .pipe(takeUntil(this.destroyObservable))
      .subscribe((faqs) => {
        this.faqs.set(faqs);
      });
  }

  onBackHandler() {
    this.navigationService.navigate([HOME_ROUTE]);
  }

  onTabChanged(): void {
    this.cdr.detectChanges();
  }
}
